module.exports = __webpack_public_path__ + "img/next-arrow.78704f27.svg";